import { render, staticRenderFns } from "./foreword.vue?vue&type=template&id=769a3379&scoped=true&"
import script from "./foreword.vue?vue&type=script&lang=js&"
export * from "./foreword.vue?vue&type=script&lang=js&"
import style0 from "./foreword.vue?vue&type=style&index=0&id=769a3379&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769a3379",
  null
  
)

export default component.exports